export const protectedPaths = ["/profile", "/dashboard"] as const;